import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_subheader = _resolveComponent("v-subheader")!
  const _component_v_list_item_icon = _resolveComponent("v-list-item-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_content = _resolveComponent("v-list-item-content")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createBlock(_component_v_list, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_subheader, null, {
        default: _withCtx(() => [
          (_ctx.$vuetify.breakpoint.xsOnly)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawerChange(false)))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-close")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _cache[2] || (_cache[2] = _createTextVNode(" STEROWANIE MAPĄ "))
        ]),
        _: 1
      }),
      _createVNode(_component_v_list_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-target")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Ustawianie pozycji ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                "input-value": _ctx.selectLocationMode,
                onChange: _ctx.handleLocationModeChange,
                label: "",
                "true-value": true,
                "false-value": false,
                color: "primary"
              }, null, 8, ["input-value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_subheader, null, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode(" FILTRY ")
        ])),
        _: 1
      }),
      _createVNode(_component_v_list_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-car-brake-parking")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Parkingi ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                "input-value": _ctx.parkingsLayer,
                onChange: _ctx.handleParkingsChange,
                label: "",
                "true-value": true,
                "false-value": false,
                color: "primary"
              }, null, 8, ["input-value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_list_group, {
        "no-action": "",
        "sub-group": ""
      }, {
        activator: _withCtx(() => [
          _createVNode(_component_v_list_item_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Podelementy")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("mdi-car")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" Grupy ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item_action, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    "input-value": _ctx.parkingGroupsLayer,
                    onChange: _ctx.handleParkingGroupsChange,
                    label: "",
                    "true-value": true,
                    "false-value": false,
                    color: "primary"
                  }, null, 8, ["input-value", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("mdi-checkbox-blank-circle")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" Miejsca ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item_action, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    "input-value": _ctx.parkingSpotsLayer,
                    onChange: _ctx.handleParkingSpotsChange,
                    label: "",
                    "true-value": true,
                    "false-value": false,
                    color: "primary"
                  }, null, 8, ["input-value", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_list_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("mdi-texture-box")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode(" Strefy parkowania ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                "input-value": _ctx.parkingZonesLayer,
                onChange: _ctx.handleParkingZonesChange,
                label: "",
                "true-value": true,
                "false-value": false,
                color: "primary"
              }, null, 8, ["input-value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_list_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_list_item_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "" }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("mdi-cash-usd-outline")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item_title, null, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode(" Parkometry ")
                ])),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list_item_action, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_switch, {
                "input-value": _ctx.parkingMetersLayer,
                onChange: _ctx.handleParkingMetersChange,
                label: "",
                "true-value": true,
                "false-value": false,
                color: "primary"
              }, null, 8, ["input-value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}